import React, { useState, useEffect } from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useHistory } from 'react-router-dom';

import logo from './../assets/logo/logo_black.svg'

import Particles from 'react-tsparticles'
import { E164Number, isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js';
import MuiPhoneNumber from 'material-ui-phone-number';

import { useAppDispatch } from '../hooks';
import { cognitoConfirmSignUp, cognitoSignIn, cognitoSignUp } from '../managers/redux/slices/authAccount';
import { toast } from 'react-toastify';
import isEmail from 'validator/lib/isEmail';
import queryString from 'query-string'
import { Code } from 'native-base';

function Copyright(props: any) {
    return (
        <Typography variant="body2" color="text.secondary" align="center" {...props}>
            {'Copyright © '}
            <Link color="inherit" href="https://flourishos.com">
                Flourish, LLC
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

export default function Authenticate() {

    const dispatch = useAppDispatch()

    const history = useHistory()

    const [screenType, setScreenType] = useState<'login' | 'register' | 'verification' | 'forgot'>('login')

    const [phoneNumber, setPhoneNumber] = useState<E164Number | undefined>(undefined)
    const [email, setEmail] = useState<string | null>(null)
    const [password, setPassword] = useState<string | null>(null)
    const [repeatPassword, setRepeatPassword] = useState<string | null>(null)

    const [verifyPhoneNumberNumber, setVerifyPhoneNumberNumber] = useState<E164Number | undefined>(undefined)
    const [verificationCode, setVerificationCode] = useState<string | null>(null)
    const [verifyPhoneNumberPassword, setVerifyPhoneNumberPassword] = useState<string | null>(null)

    const [firstName, setFirstName] = useState<string | null>(null)
    const [lastName, setLastName] = useState<string | null>(null)

    const [formattedPhoneNumber, setFormattedPhoneNumber] = useState<string>("");

    const formatPhoneNumber = (phoneNumber: string) => {
        let input = phoneNumber

        // Use a regular expression to match only numerical digits
        const digits = input.match(/\d/g) || [];

        // check if there are enough digits to add formatting
        if (digits.length >= 4) {
            input = "(" + digits.slice(0, 3).join("") + ") " + digits.slice(3).join("");
        }
        if (digits.length >= 7) {
            input = input.substring(0, 9) + "-" + digits.slice(6).join("");
        }
        setFormattedPhoneNumber(input);
        try {
            const e164 = parsePhoneNumber(input, 'US')
            if (e164 && e164.number) {
                setPhoneNumber(e164.number)
            }
        } catch (err) {

        }
    };

    useEffect(() => {
        const parsed = queryString.parse(window.location.search)
        if (parsed && parsed.t) {
            if (parsed.t == 'login') setScreenType('login')
            else if (parsed.t == 'register') setScreenType('register')
            else if (parsed.t == 'verification') setScreenType('verification')
            else if (parsed.t == 'forgot') setScreenType('forgot')
        }
    }, [])

    return (
        <Grid container component="main" sx={{ height: '100vh' }}>
            <CssBaseline />
            <Grid
                item
                xs={false}
                sm={4}
                md={7}
                sx={{
                    backgroundColor: 'white',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                }}
            >
                <Particles
                    options={{
                        "fullScreen": {
                            "enable": true,
                            "zIndex": 0
                        },
                        "fpsLimit": 120,
                        "particles": {
                            "number": {
                                "value": 5,
                                "density": {
                                    "enable": false,
                                    "area": 800
                                }
                            },
                            "color": {
                                "value": [
                                    "#00C3A0",
                                    "#80E1D0",
                                ]
                            },
                            "shape": {
                                "type": "circle"
                            },
                            "opacity": {
                                "value": 0.5,
                                "random": {
                                    "enable": true,
                                    "minimumValue": 0.4
                                },
                                "animation": {
                                    "enable": false,
                                    "speed": 1,
                                    "minimumValue": 0.1,
                                    "sync": false
                                }
                            },
                            "size": {
                                "value": 300,
                                "random": {
                                    "enable": true,
                                    "minimumValue": 200
                                },
                                "animation": {
                                    "enable": false,
                                    "speed": 100,
                                    "minimumValue": 100,
                                    "sync": false
                                }
                            },
                            "move": {
                                "enable": true,
                                "speed": 0.5,
                                "direction": "none",
                                "random": true,
                                "straight": false,
                                "outModes": {
                                    "default": "out"
                                }
                            }
                        },
                        "detectRetina": true,
                        "background": {
                            "color": "black",
                            "image": "",
                            "position": "50% 50%",
                            "repeat": "no-repeat",
                            "size": "cover"
                        }
                    }}
                />
            </Grid>
            {
                screenType == 'login' ?
                    <Grid item xs={12} sm={8} md={5} component={Paper} sx={{ backgroundColor: 'white', zIndex: 1 }} elevation={6} square>
                        <Box
                            sx={{
                                my: 8,
                                mx: 2,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center'
                            }}
                        >
                            <Button variant="text" className="mb-3" onClick={() => history.push('/')}>{`< Go Back`}</Button>
                            <div className="d-flex flex-row justify-content-center align-items-center">
                                <img src={logo} style={{ height: 40, color: 'black' }} />
                                <p style={{ fontSize: 36, fontFamily: 'Gilroy-Bold', color: 'black', padding: 0, margin: 0, marginLeft: 10 }}>Latent</p>
                            </div>
                            <Typography variant="h3" className="my-5">
                                Sign in
                            </Typography>
                            <div>
                                {/* <PhoneNumberInput
                            value={phoneNumber}
                            onChange={setPhoneNumber}
                        /> */}
                                <TextField
                                    margin="normal"
                                    required
                                    fullWidth
                                    name="phoneNumber"
                                    label="Phone Number"
                                    type="tel"
                                    id="phoneNumber"
                                    autoComplete="tel"
                                    value={formattedPhoneNumber}
                                    onChange={(e) => formatPhoneNumber(e.target.value)}
                                />
                                <TextField
                                    margin="normal"
                                    required
                                    fullWidth
                                    name="password"
                                    label="Password"
                                    type="password"
                                    id="password"
                                    autoComplete="current-password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    autoFocus={false}
                                />
                                <Button
                                    fullWidth
                                    variant="contained"
                                    sx={{ mt: 3, mb: 2 }}
                                    onClick={() => {
                                        if (phoneNumber) {
                                            const parsedPhoneNumber = parsePhoneNumber(phoneNumber, 'US')
                                            if (parsedPhoneNumber.number.length === 12) {
                                                if (password && password.length >= 8) {
                                                    dispatch(cognitoSignIn({ phoneNumber, password }))
                                                } else {
                                                    toast.error('Password does not meet minimum password criteria', { containerId: 'main' })
                                                }
                                            } else {
                                                toast.error('Invalid phone number. Phone number must be a 10 digit, US based phone number.', { containerId: 'main' })
                                            }
                                        } else {
                                            toast.error('Phone number must be a 10-digit, US-based phone number.', { containerId: 'main' })
                                        }
                                    }}
                                >
                                    Log In
                                </Button>
                                <Grid container>
                                    <Grid item xs>
                                        <Link href="#" variant="body2" onClick={() => { setScreenType('forgot') }}>
                                            Forgot password?
                                        </Link>
                                    </Grid>
                                    <Grid item>
                                        <Link href="#" variant="body2" onClick={() => setScreenType('register')}>
                                            Register
                                        </Link>
                                    </Grid>
                                </Grid>
                                <Copyright sx={{ mt: 5 }} />
                            </div>
                        </Box>
                    </Grid>
                    : screenType == 'register' ?
                        <Grid item xs={12} sm={8} md={5} component={Paper} sx={{ backgroundColor: 'white', zIndex: 1 }} elevation={6} square>
                            <Box
                                sx={{
                                    my: 8,
                                    mx: 2,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center'
                                }}
                            >
                                <Button variant="text" className="mb-3" onClick={() => history.push('/')}>{`< Go Back`}</Button>
                                <div className="d-flex flex-row justify-content-center align-items-center">
                                    <img src={logo} style={{ height: 40, color: 'black' }} />
                                    <p style={{ fontSize: 36, fontFamily: 'Gilroy-Bold', color: 'black', padding: 0, margin: 0, marginLeft: 10 }}>Latent</p>
                                </div>
                                <Typography variant="h3" className="my-5">
                                    Register
                                </Typography>
                                <div>
                                    {/* <PhoneNumberInput
                            value={phoneNumber}
                            onChange={setPhoneNumber}
                        /> */}
                                    <TextField
                                        margin="normal"
                                        required
                                        fullWidth
                                        name="phoneNumber"
                                        label="Phone Number"
                                        type="tel"
                                        id="phoneNumber"
                                        autoComplete="tel"
                                        value={formattedPhoneNumber}
                                        onChange={(e) => formatPhoneNumber(e.target.value)}
                                    />
                                    <TextField
                                        margin="normal"
                                        required
                                        fullWidth
                                        name="email"
                                        label="Email"
                                        type="email"
                                        id="email"
                                        autoComplete="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                    <TextField
                                        margin="normal"
                                        required
                                        fullWidth
                                        name="password"
                                        label="Password"
                                        type="password"
                                        id="password"
                                        autoComplete="current-password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                    <TextField
                                        margin="normal"
                                        required
                                        fullWidth
                                        name="repeat password"
                                        label="Repeat Password"
                                        type="password"
                                        id="repeat-password"
                                        autoComplete="current-password"
                                        value={repeatPassword}
                                        onChange={(e) => setRepeatPassword(e.target.value)}
                                    />
                                    <TextField
                                        margin="normal"
                                        required
                                        fullWidth
                                        name="firstName"
                                        label="First Name"
                                        id="first-name"
                                        autoComplete="given-name"
                                        value={firstName}
                                        onChange={(e) => setFirstName(e.target.value)}
                                    />
                                    <TextField
                                        margin="normal"
                                        required
                                        fullWidth
                                        name="lastName"
                                        label="Last Name"
                                        id="last-name"
                                        autoComplete="family-name"
                                        value={lastName}
                                        onChange={(e) => setLastName(e.target.value)}
                                    />
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        sx={{ mt: 3, mb: 2 }}
                                        onClick={async () => {
                                            if (phoneNumber) {
                                                const parsedPhoneNumber = parsePhoneNumber(phoneNumber, 'US')
                                                if (parsedPhoneNumber.number.length === 12) {
                                                    if (password && password.length >= 8) {
                                                        if (password == repeatPassword) {
                                                            if (email && isEmail(email)) {
                                                                if (firstName && lastName) {
                                                                    const response = await dispatch(cognitoSignUp({ phoneNumber, email, password, firstName, lastName }))
                                                                    console.log(response)
                                                                    if (response && response.payload && response.payload.email == email) {
                                                                        setScreenType('verification')
                                                                    }
                                                                } else {
                                                                    toast.error('Please enter a first and last name', { containerId: 'main' })
                                                                }
                                                            } else {
                                                                toast.error('Email is not valid', { containerId: 'main' })
                                                            }
                                                        } else {
                                                            toast.error('Passwords do not match', { containerId: 'main' })
                                                        }
                                                    } else {
                                                        toast.error('Password does not meet minimum password criteria', { containerId: 'main' })
                                                    }
                                                } else {
                                                    toast.error('Phone number must be a 10-digit, US-based phone number.', { containerId: 'main' })
                                                }
                                            } else {
                                                toast.error('Phone number must be a 10-digit, US-based phone number.', { containerId: 'main' })
                                            }
                                        }}
                                    >
                                        Register
                                    </Button>
                                    <Grid container>
                                        <Grid item xs>
                                            <Link href="#" variant="body2" onClick={() => { setScreenType('forgot') }}>
                                                Forgot password?
                                            </Link>
                                        </Grid>
                                        <Grid item>
                                            <Link href="#" variant="body2" onClick={() => setScreenType('login')}>
                                                Login
                                            </Link>
                                        </Grid>
                                    </Grid>
                                    <Copyright sx={{ mt: 5 }} />
                                </div>
                            </Box>
                        </Grid>
                        : screenType == 'verification' ?
                            <Grid item xs={12} sm={8} md={5} component={Paper} sx={{ backgroundColor: 'white', zIndex: 1 }} elevation={6} square>
                                <Box
                                    sx={{
                                        my: 8,
                                        mx: 2,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center'
                                    }}
                                >
                                    <Button variant="text" className="mb-3" onClick={() => history.push('/')}>{`< Go Back`}</Button>
                                    <div className="d-flex flex-row justify-content-center align-items-center">
                                        <img src={logo} style={{ height: 40, color: 'black' }} />
                                        <p style={{ fontSize: 36, fontFamily: 'Gilroy-Bold', color: 'black', padding: 0, margin: 0, marginLeft: 10 }}>Latent</p>
                                    </div>
                                    <Typography variant="h3" className="my-5">
                                        Verify Phone Number
                                    </Typography>
                                    <div>
                                        {/* <PhoneNumberInput
                            value={phoneNumber}
                            onChange={setPhoneNumber}
                        /> */}
                                        {
                                            phoneNumber == undefined &&
                                            <MuiPhoneNumber defaultCountry={'us'} name="phoneNumber" type="tel" countryCodeEditable={false} onChange={(e) => { console.log(e); if (typeof e == 'string' && isValidPhoneNumber(e)) setVerifyPhoneNumberNumber(parsePhoneNumber(e).number); else setVerifyPhoneNumberNumber(undefined) }} variant="outlined" placeholder="Phone Number" required fullWidth label="Phone Number" />
                                        }
                                        {
                                            password == null &&
                                            <TextField
                                                margin="normal"
                                                required
                                                fullWidth
                                                name="password"
                                                label="Password"
                                                type="password"
                                                id="password"
                                                autoComplete="current-password"
                                                value={verifyPhoneNumberPassword}
                                                onChange={(e) => setVerifyPhoneNumberPassword(e.target.value)}
                                            />}
                                        <TextField
                                            margin="normal"
                                            required
                                            fullWidth
                                            name="verificationCode"
                                            label="Verification Code"
                                            id="verification-code"
                                            autoComplete="one-time-code"
                                            value={verificationCode}
                                            onChange={(e) => setVerificationCode(e.target.value)}
                                        />
                                        <Button
                                            fullWidth
                                            variant="contained"
                                            sx={{ mt: 3, mb: 2 }}
                                            onClick={() => {
                                                if ((phoneNumber && isValidPhoneNumber(phoneNumber)) || (verifyPhoneNumberNumber && isValidPhoneNumber(verifyPhoneNumberNumber))) {
                                                    if (verificationCode && verificationCode.length == 6) {
                                                        if (password || verifyPhoneNumberPassword) {
                                                            dispatch(cognitoConfirmSignUp({ phoneNumber: phoneNumber ? phoneNumber.toString() : verifyPhoneNumberNumber ? verifyPhoneNumberNumber.toString() : '', code: verificationCode, password: password ? password : verifyPhoneNumberPassword }))
                                                        } else {
                                                            toast.error('Error reading password. Contact support.')
                                                        }
                                                    } else {
                                                        toast.error('Error confirming sign up. Contact support or try again.')
                                                    }
                                                } else {
                                                    toast.error('Invalid phone number')
                                                }
                                            }}
                                        >
                                            Verify
                                        </Button>
                                        <Grid container>
                                            <Grid item xs>
                                                <Link href="#" variant="body2">
                                                    Forgot password?
                                                </Link>
                                            </Grid>
                                            <Grid item>
                                                <Link href="#" variant="body2">
                                                    Register
                                                </Link>
                                            </Grid>
                                        </Grid>
                                        <Copyright sx={{ mt: 5 }} />
                                    </div>
                                </Box>
                            </Grid>
                            :
                            <div />
            }
        </Grid >
    );
}